import { SpinnerIcon } from '@/components/icons';

const PageLoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center h-dvh w-dvw p-3 sm:p-6 md:p-10 bg-main-gray">
      <SpinnerIcon className="animate-spin mb-9" />
    </div>
  );
};

export default PageLoadingSpinner;
